function dataStatus({ data, t }: { data: string, t: (value: string) => string }) {
  const value: { [key: string]: string } = {
    active: t('org.job_lvl.form.active'),
    inactive: t('org.job_lvl.form.inactive'),
  };
  return value[data];
}

export default dataStatus;
